import MapIcon from "@material-ui/icons/Map"
import Tune from "@material-ui/icons/Tune"
import { useMemo } from "react"
import type { ReactElement } from "react"

import { useTranslation } from "react-i18next"
import { useIsWildcardUser, useOpcoUrlPrefix } from "../../../hooks"
import type { MapDetailDto } from "../../../models"
import type { Project } from "../../../redux"
import type { MenuOption } from "../more-options-base/more-options-base.component"
import { MoreOptionsBase } from "../more-options-base/more-options-base.component"

export interface IProjectMoreOptionsProps {
  project: Project
  map: MapDetailDto
  onSave: () => void
  onSaveAs: () => void
  onHandIn: () => void
  onShare: () => void
}

export function ProjectMoreOptions(props: IProjectMoreOptionsProps): ReactElement {
  const { project, map, onSave, onSaveAs, onHandIn, onShare } = props
  const { t } = useTranslation("project")

  const isWildcardUser: boolean = useIsWildcardUser()
  const opcoPrefix: string = useOpcoUrlPrefix()
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  const optionsToShow: MenuOption[] = useMemo<MenuOption[]>(() => {
    return [
      {
        isShown: isWildcardUser,
        buttonParams: {
          icon: <Tune />,
          text: t("button.navigateMetadata"),
          onClick: () => navigateTo(`/${opcoPrefix}/manage/metadata/${map.id}`)
        }
      },
      {
        isShown: isWildcardUser,
        buttonParams: {
          icon: <MapIcon />,
          text: t("button.navigateAsset"),
          onClick: () => navigateTo(`/${opcoPrefix}/manage/metadata/${map.assetId}`)
        }
      }
    ]
  }, [isWildcardUser, map, opcoPrefix])

  function navigateTo(url: string): void {
    window.open(url, "_blank")
  }

  return (
    <MoreOptionsBase
      data={project}
      objectDescriptor="map"
      options={optionsToShow}
      onHandIn={onHandIn}
      onSave={onSave}
      onSaveAs={onSaveAs}
      onShare={onShare}
    />
  )
}
